import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Cog, LayoutDashboard } from 'lucide-react';

export const OWNER_PAGES = [
  { to: '/owner', label: 'Dashboard', icon: LayoutDashboard, testId: 'owner-nav-dashboard' },
  { to: '/owner/engine', label: 'Conversion engine', icon: Cog, testId: 'owner-nav-engine' },
];

/** Back link + the owner tools' page switcher (shared by every /owner page). */
export const OwnerNav = () => {
  const { pathname } = useLocation();
  return (
    <div className="flex flex-wrap items-center justify-between gap-2" data-testid="owner-nav">
      <Link to="/app" className="inline-flex items-center gap-1.5 text-xs text-muted-foreground rounded-sm hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" data-testid="owner-back-to-editor"><ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />Back to the editor</Link>
      <nav aria-label="Owner tools" className="inline-flex items-center gap-1 rounded-lg border border-border bg-card p-1">
        {OWNER_PAGES.map(({ to, label, icon: Icon, testId }) => {
          const active = pathname === to;
          return (
            <Link
              key={to}
              to={to}
              aria-current={active ? 'page' : undefined}
              className={`inline-flex h-8 items-center gap-1.5 rounded-md px-3 text-xs font-medium transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${active ? 'bg-primary text-primary-foreground shadow-sm' : 'text-muted-foreground hover:bg-muted hover:text-foreground'}`}
              data-testid={testId}
            >
              <Icon className="h-3.5 w-3.5" aria-hidden="true" />{label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};
